<cxone-modal [ngClass]="{
    'has-extra-content': validationError?.length || selectedFileName?.length
}" [headerTitle]="headerTitle" [modalSize]="'m'" [focusOnShow]="true" (dismissed)="cancel()" (closed)="cancel()"
    [customFooter]="true" #modalDialog id="cxone-modal">
    <div class="cxone-custom-data-import-dialog-body cx-one-ui" [formGroup]="importForm"
        [style.pointer-events]="loading ? 'none' : 'auto'" id="custom-dataImport-dialogBody">
        <div class="feed-section" id="feed-section">
            <div class="input-header" id="feed-input-header">
                <span class="label" cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Feed_Name"
                    id="feed-name-label">
                    FEED NAME
                </span>
                <span class="required" id="feed-name-required"> *</span>
            </div>
            <cxone-singleselect-dropdown id="cxone-custom-data-import-dialog-feed-name-dropdown" formControlName="feed"
                [options]="feedList" [label]="'FeedName'" [primaryKey]="'FeedName'" [isRequired]="true"
                [placeholder]="placeholderText" [sortOrder]="'asc'">
            </cxone-singleselect-dropdown>
        </div>
        <div class="upload-section" id="upload-section">
            <div class="input-header" id="upload-input-header">
                <span class="label" cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Upload_File"
                    id="upload-file-label">
                    UPLOAD FILE
                </span>
                <span class="required" id="upload-file-required"> *</span>
            </div>
            <span class="info" cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Upload_Info"
                id="upload-info-span">
                Only CSV (.csv or .txt) files are supported. File can be up to 15 MB.
            </span>
            <button (click)="uploader.click()" id="browse-file-button"
                class="cxone-btn btn-big btn-secondary btn-bg-is-white" tabindex="0" cvLocalizedText
                langSection="CXone_Custom_Data_Import" langKey="Browse_File_Button">
                Browse File
            </button>
            <div class="file-details-container" id="file-details-container">
                <span class="filename-container" *ngIf="selectedFileName?.length" id="filename-container">
                    <span placement="bottom" [ngbPopover]="filenameTooltip" container=".cx-one-ui"
                        triggers="mouseenter:mouseleave" class="filename" id="selected-fileName">{{
                        selectedFileName }}</span>
                    <ng-template #filenameTooltip>{{ selectedFileName }}</ng-template>
                    <button (click)="clearFile(uploader)" id="clear-file-button" class="close-tag">
                        <svg>
                            <use href="../App_Themes/CXone/icons/close.svg#close" id="close-svg-icon">
                            </use>
                        </svg>
                    </button>
                </span>
                <span class="errors-container" *ngIf="validationError?.length" id="errors-container">
                    <cxone-embedded-messages [messageType]="validationErrorType === 0? 'user-error': 'user-warning'"
                        [messageData]="validationError" [id]="validationErrorType === 0? 'user-error': 'user-warning'"
                        id="embeddedMessages">
                    </cxone-embedded-messages>
                </span>
            </div>
            <input hidden id="file-uploader" formControlName="file" type="file" accept=".csv, .txt" #uploader
                (change)="uploadFile($event)" />
        </div>
    </div>
    <cxone-modal-footer [style.pointer-events]="loading ? 'none' : 'auto'">
        <div class="cxone-custom-data-import-dialog-footer cx-one-ui" id="custom-data-import-dialog-footer">
            <button cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Cancel_Button" (click)="cancel()"
                id="cancel-button" class="cxone-btn btn-md btn-secondary" tabindex="0">
                Cancel
            </button>
            <button cvLocalizedText langSection="CXone_Custom_Data_Import" langKey="Submit_Button" (click)="save()"
                id="submit-button" class="cxone-btn btn-md btn-primary" tabindex="0"
                [disabled]="importForm.invalid || validationError?.length || loading || validatingColumns">
                Submit
            </button>
        </div>
    </cxone-modal-footer>
</cxone-modal>